import type { CommandeDetail, CreationExpeditionPayload } from "@/types/domain";

const nettoyer = (valeur: string) => valeur.replace(/[^A-Za-z0-9_-]/g, "-");

export const creerCleExpedition = (
  prefixe: "CREATE" | "CONFIRM",
  reference: string,
  horodatage = Date.now(),
  alea = Math.random().toString(36).slice(2, 10),
) => `EXP:${prefixe}:${nettoyer(reference)}:${horodatage}:${nettoyer(alea)}`;

export function construireCreationExpedition(
  commande: CommandeDetail,
  quantites: Record<string, number>,
  idempotencyKey: string,
): CreationExpeditionPayload {
  if (commande.statut !== "PRET") throw new Error("La commande n'est pas PRET.");
  const lignes = commande.lignes.flatMap((ligne) => {
    const quantite = quantites[ligne.id] || 0;
    if (quantite === 0) return [];
    const restante = ligne.quantite_demandee - ligne.quantite_expediee;
    if (!Number.isInteger(quantite) || quantite < 0 || quantite > restante)
      throw new Error(`Quantité invalide pour ${ligne.sku}.`);
    if (quantite > ligne.quantite_reservee)
      throw new Error(`Réservation insuffisante pour ${ligne.sku}.`);
    return [{ ligne_commande_id: ligne.id, quantite }];
  });
  if (lignes.length === 0) throw new Error("Sélectionnez au moins une quantité.");
  return { idempotency_key: idempotencyKey, lignes };
}

